module.exports = __webpack_public_path__ + "img/1.20ca52b6.jpg";